import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import { Box, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useMemo } from "react";

import { buildOperatorLoanSummary } from "./operatorLoanSummary";
import {
  OPERATOR_CARD_SX,
  OPERATOR_LOAN_STAT_BOX_SX,
  OPERATOR_LOAN_STATS_SX,
  OPERATOR_LOAN_VALUE_SX,
  OPERATOR_META_LABEL_SX,
} from "./operatorReviewStyles";

const LoanStat = ({ label, value }) => (
  <Box sx={OPERATOR_LOAN_STAT_BOX_SX}>
    <Typography sx={{ ...OPERATOR_META_LABEL_SX, mb: 0.75 }}>{label}</Typography>
    <Typography sx={OPERATOR_LOAN_VALUE_SX}>{value}</Typography>
  </Box>
);

LoanStat.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

const OperatorLoanSummaryCard = ({ values }) => {
  const loan = useMemo(() => buildOperatorLoanSummary(values), [values]);

  if (!loan.show) return null;

  return (
    <Box sx={{ ...OPERATOR_CARD_SX, p: { xs: 2, md: 2.5 } }}>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
        <AccountBalanceOutlinedIcon color="primary" />
        <Typography variant="subtitle1" fontWeight={800}>
          خلاصه مالی و وام
        </Typography>
        {loan.active && loan.loanTypeLabel ? (
          <Typography variant="body2" color="text.secondary" sx={{ mr: "auto" }}>
            {loan.loanTypeLabel}
          </Typography>
        ) : null}
      </Stack>

      {loan.active ? (
        <Box sx={OPERATOR_LOAN_STATS_SX}>
          {loan.chequeIntentLabel ? (
            <LoanStat label="وضعیت چک صیادی" value={loan.chequeIntentLabel} />
          ) : null}
          <LoanStat label="سقف وام" value={loan.ceilingLabel} />
          <LoanStat label="مدت بازپرداخت" value={loan.monthsLabel} />
          <LoanStat label="قسط ماهانه" value={loan.installmentLabel} />
        </Box>
      ) : (
        <Typography variant="body1" color="text.secondary" fontWeight={600}>
          {loan.message}
        </Typography>
      )}
    </Box>
  );
};

OperatorLoanSummaryCard.propTypes = {
  values: PropTypes.object.isRequired,
};

export default OperatorLoanSummaryCard;
